//skills array containing skill information for resume

const skills = [
  {
    name: "JavaScript",
    alt: "JavaScript icon",
    description:
      "JavaScript is currently my most comfortable programming language by a large margin. I certainly don't know everything, but am confident in my ability to figure out any problem when JavaScript is the tool I'm utilizing.",
    src: "/assets/images/js-icon.webp",
    width: 50,
    height: 70,
    href: "#javascript-skill",
    id: "javascript-skill",
    proficiency: "skilled",
  },
  {
    name: "React",
    alt: "React icon",
    description:
      "Having now built multiple projects using React, I feel secure in my ability to work with the framework in a professional capacity. I know there is much more to learn, and I am excited to begin learning related frameworks such as Next.js and React Native.",
    src: "/assets/images/react-icon.webp",
    width: 57,
    height: 70,
    href: "#react-skill",
    id: "react-skill",
    proficiency: "skilled",
  },
  {
    name: "Next.js",
    alt: "Next.js icon",
    description:
      "Next.js is a React framework that enables server-side rendering and static site generation. I have started exploring its features and appreciate its ability to improve performance and SEO for web applications.",
    src: "/assets/images/nextjs-icon.webp",
    width: 70,
    height: 70,
    href: "#nextjs-skill",
    id: "nextjs-skill",
    proficiency: "experienced",
  },
  {
    name: "TypeScript",
    alt: "TypeScript icon",
    description:
      "I enjoy using TypeScript and immediately appreciated its ease and type-safe nature (my first type-safe language). I have not encountered any difficulties with it thus far, and will be using it in upcoming personal projects.",
    src: "/assets/images/typescript-icon.webp",
    width: 70,
    height: 70,
    href: "#typescript-skill",
    id: "typescript-skill",
    proficiency: "experienced",
  },
  {
    name: "MongoDB",
    alt: "MongoDB icon",
    description:
      "MongoDB is a NoSQL database that I have used for storing and managing data in web applications. I am familiar with its document-oriented model and basic operations.",
    src: "/assets/images/mongodb-icon.webp",
    width: 70,
    height: 70,
    href: "#mongodb-skill",
    id: "mongodb-skill",
    proficiency: "skilled",
  },
  {
    name: "PostgreSQL",
    alt: "PostgreSQL icon",
    description:
      "PostgreSQL is a powerful, open-source relational database system. I have used it for managing structured data and am familiar with its SQL querying capabilities.",
    src: "/assets/images/postgreSQL-icon.webp",
    width: 70,
    height: 70,
    href: "#postgresql-skill",
    id: "postgresql-skill",
    proficiency: "skilled",
  },
  // {
  //     name: 'CSS',
  //     alt: 'CSS icon',
  //     description: "Once fraught with some difficulties, CSS has become a welcome and familiar tool, and one which I enjoy exploring the possibilities of. One aspect I'm keen on diving deeper into is more complex animations and transitions.",
  //     src: "/assets/images/css-icon.png",
  //     href: '#css-skill',
  //     id: 'css-skill',
  //     proficiency: 'skilled'
  // },
  // {
  //     name: 'HTML',
  //     alt: 'HTML icon',
  //     description: "I'm as comfortable with HTML as I am anything, and I am also prepared to build pages which adhere to accessibility guidelines and account for SEO best practices.",
  //     src: "/assets/images/html-icon.png",
  //     href: '#html-skill',
  //     id: 'html-skill',
  //     proficiency: 'skilled'
  // },
  {
    name: "Node.js",
    alt: "Node.js icon",
    description:
      "Node.js is relatively recent to me, and while I've completed the Codecademy course, I have much to learn and absorb more fully regarding its possibilities. Mastering this language is one of my ongoing endeavors.",
    src: "/assets/images/node-js-icon.webp",
    width: 62,
    height: 70,
    href: "#nodejs-skill",
    id: "nodejs-skill",
    proficiency: "experienced",
  },
  {
    name: "Java",
    alt: "Java icon",
    description:
      "Java is a robust, object-oriented programming language that I have experience with for enterprise applications and backend development.",
    src: "/assets/images/java-icon.webp",
    width: 43,
    height: 70,
    href: "#java-skill",
    id: "java-skill",
    proficiency: "skilled",
  },
  {
    name: "Python",
    alt: "Python icon",
    description:
      "My first programming language, it was once my most mastered and experienced, though it has been usurped by JavaScript. Given some minimal refreshing, I would have no discomfort returning to and making use of my Python foundations.",
    src: "/assets/images/python-icon.webp",
    width: 58,
    height: 70,
    href: "#python-skill",
    id: "python-skill",
    proficiency: "experienced",
  },
  {
    name: "Handlebars.js",
    alt: "Handlebars icon",
    description:
      "I learned HandleBars before I learned React, and - while I could certainly brush off the rust quickly - have not used the framework in great frequency since becoming familiar with React.",
    src: "/assets/images/handlebars-icon.webp",
    width: 93,
    height: 70,
    href: "#handlebarsjs-skill",
    id: "handlebarsjs-skill",
    proficiency: "experienced",
  },
  {
    name: "Bootstrap",
    alt: "Bootstrap icon",
    description:
      "Feeling the need to know a CSS/HTML framework, I learned Bootstrap and grew to appreciate its ease of use. I still enjoy building sites from CSS scratch, but am able to use Bootstrap for components I haven't yet learned to implement myself.",
    src: "/assets/images/bootstrap-icon.webp",
    width: 62,
    height: 70,
    href: "#bootstrap-skill",
    id: "bootstrap-skill",
    proficiency: "experienced",
  },
  {
    name: "Angular.js",
    alt: "Angular.js icon",
    description:
      "Like Handlebars.js, I learned the basics of Angular before moving on to React. That said, I'm confident in my ability to tackle projects in Angular if needed.",
    src: "/assets/images/angular-icon.webp",
    width: 66,
    height: 70,
    href: "#angularjs-skill",
    id: "angularjs-skill",
    proficiency: "experienced",
  },
  /*
    {
        name: 'C++',
        alt: 'C++ icon',
        description: "C++ is a recent language for me but learning it is my ongoing priority for systems programming.",
        src: "/assets/images/c-plus-plus-icon.webp", 
        href: '#cplusplus-skill',
        id: 'cplusplus-skill',
        proficiency: 'experienced'
    },
  */
];

export default skills;
